import * as API from "middleware/api";

export const registerUserDeviceSoftToken = ({ idDevice, extraInfo, shortLabel, _fingerprintData }) =>
    API.executeWithAccessToken("/preferences.softToken.registerDevice", {
        idDevice,
        extraInfo,
        shortLabel,
        _fingerprintData,
    });
export const registerUserDeviceSoftTokenReplace = ({ idDevice, extraInfo, shortLabel, _password, _fingerprintData }) =>
    API.executeWithAccessToken("/preferences.softToken.replaceDevice", {
        idDevice,
        extraInfo,
        shortLabel,
        _password,
        _fingerprintData,
    });
export const registerUserDeviceSoftTokenOnboarding = (
    { idDevice, extraInfo, shortLabel, _fingerprintData },
    exchangeToken,
) =>
    API.executeWithExchangeToken(
        "/onboarding.softToken.registerDevice",
        {
            idDevice,
            extraInfo,
            shortLabel,
            _fingerprintData,
        },
        exchangeToken,
    );
export const deleteUserDeviceSoftToken = (idDevice, shortLabel, _password) =>
    API.executeWithAccessToken("/preferences.softToken.deleteDevice", {
        idDevice,
        shortLabel,
        _password,
    });
export const getDevicesByUser = () => API.executeWithAccessToken("/preferences.softToken.listDevices");

export const getUserDeviceSoftToken = (registeredDeviceId, uuid) =>
    API.executeWithAccessToken("/preferences.softToken.getRegisteredDevice", { registeredDeviceId, uuid });

export const getUserDeviceStatusSoftToken = (deviceIdentification, uuid) =>
    API.executeAnonymous("/softToken.getRegisteredDeviceStatus", {
        deviceIdentification,
        uuid,
    });
